import { render } from "./Pagination.vue?vue&type=template&id=120ff47e&scoped=true"
import script from "./Pagination.vue?vue&type=script&lang=js"
export * from "./Pagination.vue?vue&type=script&lang=js"

import "./Pagination.vue?vue&type=style&index=0&id=120ff47e&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120ff47e"]])

export default __exports__